<p8-page-block>
  <div class="p8-page-block-header">
    <span class="p8-secondary">{{ file?.name }}</span>
  </div>
  <div class="p8-page-block-content" fxLayout="row">
    <div class="p8-bdc_image-form__image-container">
      <img [src]="url" [alt]="file?.name">
    </div>
    <form class="p8-bdc_page-form__max-width" [formGroup]="imageForm" fxLayout="column" fxFlex>
      <mat-form-field>
        <input matInput
               placeholder="Titre"
               id="title"
               formControlName="title"
               required>
        <mat-error *ngIf="imageForm.controls.title.errors?.required">
          Le titre est obligatoire.
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <textarea matInput
                  placeholder="Description"
                  id="description"
                  formControlName="description">
        </textarea>
      </mat-form-field>
    </form>
  </div>
</p8-page-block>
